module.exports = __webpack_public_path__ + "static/img/download.5a188d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/download.png
// module id = tb+O
// module chunks = 5